import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import { Link } from 'react-router-dom';
import { api } from '../api/http';
import { DashboardPageShell, DashboardPanel, DashboardPrimaryActionButton } from '../components/dashboard';

export function CompanyDetailsContent({ showOperationsLink = true }) {
  const [form, setForm] = useState({ name: '', address: '', city: '', state: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    api.get('/api/customers/me/company', { skipCustomer: true })
      .then(({ data }) => active && setForm({ name: data.name || '', address: data.address || '', city: data.city || '', state: data.state || '' }))
      .catch(() => active && setError('Unable to load company details safely.'))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, []);

  const update = (field) => (event) => setForm((current) => ({ ...current, [field]: event.target.value }));
  async function save() {
    setMessage(''); setError('');
    const normalized = Object.fromEntries(Object.entries(form).map(([key, value]) => [key, value.trim()]));
    if (Object.values(normalized).some((value) => !value)) {
      setError('Company name, facility address, city, and state are required.');
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.put('/api/customers/me/company', normalized, { skipCustomer: true });
      setForm(data);
      setMessage('Company details saved.');
    } catch {
      setError('Company details could not be saved. No changes were confirmed.');
    } finally { setSaving(false); }
  }
  return <>
      {message && <div className="auth-onboarding-alert auth-onboarding-alert-success">{message}</div>}
      {error && <div className="auth-onboarding-alert auth-onboarding-alert-error">{error}</div>}
      <label className="auth-onboarding-label" htmlFor="company-name">Company name</label>
      <Input id="company-name" value={form.name} onChange={update('name')} disabled={loading || saving} />
      <label className="auth-onboarding-label" htmlFor="company-address">Facility / operating street address</label>
      <Input id="company-address" value={form.address} onChange={update('address')} disabled={loading || saving} />
      <label className="auth-onboarding-label" htmlFor="company-city">City</label>
      <Input id="company-city" value={form.city} onChange={update('city')} disabled={loading || saving} />
      <label className="auth-onboarding-label" htmlFor="company-state">State</label>
      <Input id="company-state" value={form.state} onChange={update('state')} disabled={loading || saving} />
      <div className="customer-settings-action-row company-details-actions">
        <DashboardPrimaryActionButton className="fleet-add-button" onClick={save} loading={saving} disabled={loading || saving}>Save company details</DashboardPrimaryActionButton>
      </div>
      {showOperationsLink && <p><Link to="/customer/settings#operations">Manage operating schedule in Settings → Operations</Link></p>}
  </>;
}

export default function CompanyDetailsPage() {
  return <DashboardPageShell title="Company Details" productDashboardShell="customer">
    <DashboardPanel className="company-details-panel">
      <CompanyDetailsContent />
    </DashboardPanel>
  </DashboardPageShell>;
}
